import { memo } from "react";
import useECommerceActions from "features/onboarding/useECommerceActions";
import { ApplicationsTableResource } from "../common";

const ECommerceApplications = () => {
    const {
        getApplications,
        downloadCsv,
    } = useECommerceActions();

    return (
        <ApplicationsTableResource
            fetchTableData={getApplications}
            downloadCsv={downloadCsv}
            resourceName='E-Commerce'
        />
    );
};

export default memo(ECommerceApplications);
